import { useTheme } from '@mui/material';

export const EmailIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="8" y="8.5" width="23" height="20" rx="4" fill={primaryBackground} />
            <path
                d="M4.90667 7.26666L15.1733 15.3467C15.4087 15.5327 15.7 15.6339 16 15.6339C16.3 15.6339 16.5913 15.5327 16.8267 15.3467L27.0933 7.26666M26.6667 25.3333H5.33333C4.97971 25.3333 4.64057 25.1928 4.39052 24.9428C4.14048 24.6928 4 24.3536 4 24V7.99999C4 7.64637 4.14048 7.30723 4.39052 7.05718C4.64057 6.80713 4.97971 6.66666 5.33333 6.66666H26.6667C27.0203 6.66666 27.3594 6.80713 27.6095 7.05718C27.8595 7.30723 28 7.64637 28 7.99999V24C28 24.3536 27.8595 24.6928 27.6095 24.9428C27.3594 25.1928 27.0203 25.3333 26.6667 25.3333Z"
                stroke={primaryStroke}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
